var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { SceneGraphNode } from 'src/app/engine/models/scene-graph.model';
import { UIConfigModel } from 'src/app/story/models/ui-config.model';
import { LayerSetsModel } from 'src/app/story/models/layers.model';
// Instructs loader what to do on load complete
export class StoryAnimationModel {
}
import { CameraModel } from '../../engine/models/camera.model';
import { Type } from 'class-transformer';
export class AssetLibrary {
}
const ɵ0 = () => SceneGraphNode, ɵ1 = () => CameraModel, ɵ2 = () => UIConfigModel, ɵ3 = () => LayerSetsModel;
export class StoryModel {
}
__decorate([
    Type(ɵ0),
    Type(ɵ1),
    Type(ɵ2),
    Type(ɵ3),
    __metadata("design:type", String)
], StoryModel.prototype, "moduleId", void 0);
export { ɵ0, ɵ1, ɵ2, ɵ3 };
